export default ({ currentFrequency }) => ({
  frequency: null,
  ...(currentFrequency && {
    interval: 1,
  }),
  ...(currentFrequency === 'weekly' && {
    days: {
      su: false,
      mo: false,
      tu: false,
      we: false,
      th: false,
      fr: false,
      sa: false,
    },
  }),
});
